module.exports = __webpack_public_path__ + "img/screwdriver.be5030ca.webp";